import { React, useState, useEffect, View, useRef } from 'react';
import { Button, Modal } from "react-bootstrap";
import CircularProgress from "@mui/material/CircularProgress";
//import { auth } from '../firebase';
import { useNavigate, useLocation } from 'react-router-dom';
import BottomTabNavigation from './BottomTabNavigation';
import Konsensus_Constants from '../constants/index.js';
import { Paper, Stack, Box } from "@mui/material";
import NewPostModal from './NewPostModal';
import axios from "axios";
import { useParams } from "react-router-dom";
import { COLORS, SIZES, FONTS, images } from '../constants'
import DOMPurify from "dompurify";
import he from "he";

// Inside your component
const FLARUM_API_URL = Konsensus_Constants.FORUM_URL+'/api/discussions/';

// Per-post Like/Unlike button
function PostLikeButton({ postId, initialLiked, initialCount, userId, authToken }) {
  const [liked, setLiked] = useState(initialLiked);
  const [count, setCount] = useState(initialCount);
  const [loading, setLoading] = useState(false);

  const handleClick = () => {
    setLoading(true);
    if (liked) {
      // Unlike
      axios
        .delete(Konsensus_Constants.FORUM_URL+`/posts/${postId}/relationships/likes/${userId}`, {
          headers: { Authorization: `Token ${authToken}` },
        })
        .then(() => {
          setLiked(false);
          setCount((c) => c - 1);
        })
        .finally(() => setLoading(false));
    } else {
      // Like
      axios
        .post(
          Konsensus_Constants.FORUM_URL+`/posts/${postId}/relationships/likes`,
          { data: [{ type: "users", id: String(userId) }] },
          { headers: { Authorization: `Token ${authToken}` } }
        )
        .then(() => {
          setLiked(true);
          setCount((c) => c + 1);
        })
        .finally(() => setLoading(false));
    }
  };

  return (
    <button onClick={handleClick} disabled={loading}>
      {liked ? "Unlike" : "Like"} ({count})
    </button>
  );
}

export default function ForumDetail() {
  const { discussionId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [discussion, setDiscussion] = useState(null);
  const [loading, setLoading] = useState(true);
  const [posts, setPosts] = useState([]);
  const [users, setUsers] = useState({});
  const scrollViewRef = useRef(null);
  const [modalVisible, setModalVisible] = useState(false);

  const checkLogin = async() => {
    if( window.location.href!='https://app.konsensus.tech/' && window.location.href!='https://app.dev.konsensus.tech/' && window.location.href!='https://app.accept.konsensus.tech/' && window.location.href!='https://app.accept.konsensus.tech/register' && window.location.href!='https://app.accept.konsensus.tech/forgotten_password'){
        try{
            let login_data = await Konsensus_Constants._retrieveDataLocal("login_response");
            // console.log("Checking login: "+JSON.stringify(login_data));
            if( login_data.login_response.data ){
                let res = await fetch(Konsensus_Constants.FORUM_URL+'/api/users?filter[self]=1&userId='+login_data.login_response.data.userId, {
                  headers: { 'Authorization': 'Token '+login_data.login_response.data.token }
                });
                // console.log(res);
                if (res.status !== 200) {
                  //alert('Session expired!');
                  Konsensus_Constants.clear();
                  navigate('/', { state: { message: "Either your login has expired or you haven't confirmed e-mail yet!" } });
                }
            }else{
              Konsensus_Constants.clear();
              navigate('/', { state: { message: "Either your login has expired or you haven't confirmed e-mail yet!" } });
            }
        } catch (error) {
          console.error(error);
          Konsensus_Constants.clear();
          navigate('/', { state: { message: "Either your login has expired or you haven't confirmed e-mail yet!" } });
        }
    }
    console.log(window.location.href);
  }

  setInterval(async () => {
    checkLogin();
  }, 5 * 60 * 1000); // every 5 minutes

  useEffect(() => {
    fetchData();
  }, [discussionId]);

    const fetchData = async () => {
      try {
        let login_data = await Konsensus_Constants._retrieveDataLocal("login_response");
        const response = await fetch(`${FLARUM_API_URL}${discussionId}?include=posts,user,posts.user`, {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Authorization': 'Token ' + login_data?.login_response?.data?.token
          }
        });

        const json = await response.json();

        // Safely check that json.data exists
        if (!json?.data) {
          console.warn("No discussion data returned from API");
          setDiscussion(null);
          setPosts([]);
          setUsers({});
          setLoading(false);
          return;
        }

        setDiscussion(json.data);

        // Safely get included posts and users
        const included = json.included ?? [];
        const postsArr = included.filter(obj => obj.type === 'posts').sort(
          (a, b) => a.attributes.number - b.attributes.number
        );
        setPosts(postsArr);

        const usersData = included.filter(obj => obj.type === 'users');
        const userMap = {};
        usersData.forEach(user => { userMap[user.id] = user; });
        setUsers(userMap);

      } catch (error) {
        console.error("fetchData error:", error);
      } finally {
        setLoading(false);
      }
    };

  if (!discussion){
       return (
         <div className="root-loading-overlay" style={styles.rootLoadingOverlay}>
           <div className="spinner" style={styles.spinner}><div><CircularProgress sx={{ color: '#00aaaf' }} style={{width:100, height:100,}}/></div></div>
         </div>
       );
  }

  const handleSubmit = async (post) => {
    try{
      let login_data = await Konsensus_Constants._retrieveDataLocal("login_response")

      let AXIOS_CONFIG = {
        credentials: "include",
        headers: {
          'Accept': 'application/json',
          'Authorization': 'Token '+login_data.login_response.data.token
        }
      }
      // console.log(login_data.login_response.data.token);
      // Handle new conversation data here (e.g. send via API)
      let response2 = await axios.post(Konsensus_Constants.FORUM_URL+'/api/posts', {
                        "data": {
                          "type": "posts",
                          "attributes": {
                            "content": post,
                            "contentType": "comment"
                          },
                          "relationships": {
                            "discussion": {
                              "data": { "type": "discussions", "id": discussion.id }
                            }
                          }
                        }
                      }, AXIOS_CONFIG);

      // console.log(response2);
      // console.log('New post', post);
      fetchData();
    } catch (error) {
      console.error(error);
    }
  };

  function RawHTMLExample({ htmlString }) {
    const cleanHtml = DOMPurify.sanitize(he.decode(htmlString));
    return <div style={styles.postMeta2} dangerouslySetInnerHTML={{ __html: cleanHtml }} />;
  }

  return (
    <Box sx={{
                 height: "100vh", // Fill viewport height
                 display: "flex",
                 flexDirection: "column",
               }}>
       <Paper elevation={3} sx={{ p: 2 }}>
           <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
             <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
               <img src={require('../assets/images/banner.png')}
                             style={{
                              height: 97,
                              width: 380,
                              marginBottom: 0,
                              marginTop: 20,
                             }}/>
             </div>
             <div style={{ display: 'flex', gap: 8 }}>
                <Button onClick={() => setModalVisible(true)} style={{backgroundColor: "#00aaaf",
                                                                                                                                                            borderColor: "#00aaaf",
                                                                                                                                                            fontSize: 12,
                                                                                                                                                            padding: '6px 12px'}} className="chat-rounded2">Reply</Button>
             </div>
           </div>
       </Paper>
      <Paper elevation={3}
                     sx={{
                       flex: 1,        // fill all available vertical space
                       width: "100%",  // fill horizontal space
                       p: 2,
                     }}>
            <div style={styles.container}>
              { modalVisible &&
                <NewPostModal
                  visible={modalVisible}
                  onClose={() => setModalVisible(false)}
                  handleSubmit={handleSubmit}
                />
                }
                      <div style={{alignItems: 'center', paddingBottom: 0, paddingTop: 0}}>
                        <div style={{paddingBottom:10}}></div>
                      </div>
                      <div ref={scrollViewRef} style={styles.container}>
                        <div style={{
                            fontSize: 24, fontWeight: 'bold', marginBottom: 8, color: "#00aaaf"
                          }} className="title">{discussion.attributes.title}</div>
                        <div style={styles.postMeta}><b>Slug:</b> {discussion.attributes.slug}</div>
                        <div style={styles.postMeta}><b>Created At:</b> {new Date(discussion.attributes.createdAt).toLocaleString()}</div>
                        <div style={styles.postMeta}><b>Comments:</b> {discussion.attributes.commentCount}</div>
                        <div style={styles.postsContainer}>
                        {posts.map(post => {
                            const userId = post.relationships?.user?.data?.id;
                            const user = userId ? users[userId] : null;

                            const displayName = user?.attributes?.displayName ?? user?.attributes?.username ?? "Unknown";
                            const avatarInitial = displayName[0] ?? "?";
                            const avatarUrl = user?.attributes?.avatarUrl;

                            return (
                              <div key={post.id} style={styles.post}>
                                <div style={styles.userContainer}>
                                  {avatarUrl ? (
                                    <div style={styles.avatar}>
                                      <img src={avatarUrl} style={styles.avatar}/>
                                    </div>
                                  ) : (
                                    <div style={{ ...styles.avatar, ...styles.avatarPlaceholder }}>{avatarInitial}</div>
                                  )}
                                  <div style={styles.userInfo}>
                                    <div style={styles.username}>{displayName}</div>
                                    <div style={styles.postMeta}>
                                      #{post.attributes.number} • {new Date(post.attributes.createdAt).toLocaleString()}
                                    </div>
                                  </div>
                                </div>
                                <RawHTMLExample htmlString={post.attributes.contentHtml || ''} />
                                <div style={styles.hr} />
                              </div>
                            );
                        })}
                        </div>
                      <div style={{alignItems: 'center', paddingBottom: 20, paddingTop: 0}}>
                        <div style={{paddingBottom:10}}><Button onClick={() => setModalVisible(true)} style={{backgroundColor: "#00aaaf",
                                                                                                                                                                                                    borderColor: "#00aaaf",
                                                                                                                                                                                                    fontSize: 12,
                                                                                                                                                                                                    padding: '6px 12px'}} className="chat-rounded2">Reply</Button></div>
                      </div>
                      </div>
             </div>
      </Paper>
      <BottomTabNavigation />
    </Box>
  );
}
const styles = {
  container: { padding: 16, paddingTop:10, flex: 1 },
  title: { fontSize: 24, fontWeight: 'bold', marginBottom: 8, color: COLORS.primary },
  commentCount: { fontSize: 16, marginBottom: 14 },
  postsContainer: { marginTop: 10 },
  post: { marginBottom: 22 },
  userContainer: { flexDirection: 'row', alignItems: 'center', marginBottom: 4 },
  avatar: { width: 36, height: 36, borderRadius: 18, marginRight: 10, backgroundColor: '#e7f4f6', float: "left", display: 'flex', alignItems: 'center', justifyContent: 'center',},
  avatarPlaceholder: { backgroundColor: '#e7f4f6', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#00aaaf', },
  userInfo: { flexDirection: 'column' },
  username: { fontSize: 16, fontWeight: '600', color: '#00aaaf' },
  postMeta: { fontSize: 12, color: '#888' },
  postMeta2: { fontSize: 14, color: '#282828' },
  hr: { height: 1, backgroundColor: '#ddd', marginTop: 8, marginBottom: 4 },
  error: { fontSize: 18, color: 'red', padding: 16 },
      btn: {
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'row',
          backgroundColor: COLORS.primary,
          width: 300,
          paddingVertical: SIZES.padding * 2,
      },
      btnText: {
          ...FONTS.body3,
          color: COLORS.white,
          marginLeft: 8,
      },
    rootLoadingOverlay: {
      position: "fixed",
      top: 0, left: 0, right: 0, bottom: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: "#fffk",
      zIndex: "9999k",
    },
    spinner: {
      fontSize: "2rem",
      fontWeight: "bold",
      color: "#00aaaf",
    },
};